export default __webpack_public_path__ + "static/media/pic3.072c198d.jpg";